import React, { Component } from "react";
class Modal extends Component {
  render() {
    return (
      <div>
        <div
          id="modal"
          style={{
            // backgroundColor:'#000',
            zIndex: "10",
            position: "fixed",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "center",
            bottom:'4px'
          }}
          onClick={function (e) {
            if (e.target !== e.currentTarget) return;
            // e.currentTarget.style.display = "none";
          }}
        >
          <img
                id='img'
                src='/Images/jake_hat.png'
                alt="instruction gif"
                style={{
                  zIndex: 0,
                  position:'fixed',
                  bottom:'6%',
                  height: "45%",
                  marginBottom: "100px",
                  borderRadius: "5px",
                }}
              />
          <div
            id="container"
            style={{
              zIndex:1,
              display: "flex",
              flexDirection: "column",
              bottom:'0px',
              width: "auto",
              height: "auto",
              maxWidth: "80%",
              maxHeight: "80%",
              backgroundColor: "#FFF",
              padding: "0px 32px",
              paddingBottom: "32px",
              borderRadius: "5px",
              border: "2px solid #555",
              boxShadow:
                "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px",
              overflowY: "scroll",
            }}
            onClick={function (e) {
              console.log("container clicked");
            }}
          >
            <h2 id='insurance_type' style={{marginBottom:'0px', color:'#d62311'}}> Type of Insurance </h2>
            <h4 id='insurance_description' style={{marginBottom:'0px', color:'#000'}}>This is a long description of the type of insurance clicked</h4>
            <h3 id='call_to_action' style={{color:'#403c3c'}}>Call to action sentense</h3>
            <span>
              <input id='input' placeholder="Zip Code"
                style={{
                  background: "#fff",
                  border: 0,
                  borderRadius: 0,
                  boxShadow: "inset 0 -1px 0 0 #767676, inset -1px 0 0 #f4f3f3, inset 1px 0 0 #f4f3f3, inset 0 1px 0 0 #f4f3f3",
                  color: '#212121',
                  fontSize: '16px',
                  height: '25px',
                  letterSpacing: '0',
                  padding: '0 16px',
                  position: 'relative',
                  width: '7EM',
                  paddingBottom: '0px',
                  paddingTop: '15px'
                }}
              ></input>
              <button
                style={{
                  top:'-5px',
                  background: "#F01716",
                  border: 0,
                  borderRadius: '28px',
                  boxShadow: "inset 0 -1px 0 0 #767676, inset -1px 0 0 #f4f3f3, inset 1px 0 0 #f4f3f3, inset 0 1px 0 0 #f4f3f3",
                  color: '#fff',
                  fontSize: '16px',
                  height: '35px',
                  letterSpacing: '0',
                  padding: '0 16px',
                  position: 'relative',
                  width: '10EM',
                  paddingBottom: '0px',
                  paddingTop: '3px',
                }}
                onClick={()=>{window.open('https://www.statefarm.com', '_blank')}}
              >Learn more</button>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;
